import { RowBase, makeObservableRowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IIconsVector } from 'shared/ui'
import { type IPaymentStatus, type IResponseBillingPayment } from 'entities/Billing/api/types'
import { getPaymentMethodLabel, getPaymentMethodIcon } from 'entities/Billing/model/Source'

type IPaymentHistoryRowOrigin = {
  id: string
  payment: IResponseBillingPayment
}

export class PaymentHistoryRow extends RowBase<IPaymentHistoryRowOrigin> {
  constructor(origin: IPaymentHistoryRowOrigin) {
    super(origin)
    makeObservableRowBase(this)
  }

  get payment() {
    return this.origin.payment
  }

  get status(): IPaymentStatus {
    if (this.payment.amount_refunded > 0) {
      return 'refunded'
    }
    return this.payment.status
  }

  get amount() {
    return this.payment.amount
  }

  get createdAt() {
    return this.payment.created_at
  }

  get brand() {
    return this.payment.brand
  }

  get last4() {
    return this.payment.last4
  }

  get label(): string {
    return getPaymentMethodLabel(this.brand)
  }

  get icon(): IIconsVector {
    return getPaymentMethodIcon(this.brand)
  }

  get failureMessage(): string | null {
    return this.payment.failure_message
  }
}
